export const OurTourList = [
	{
		carousel: [
			"./photos/city_walking_tour/1.jpg",
			"./photos/city_walking_tour/2.jpg",
			"./photos/city_walking_tour/3.jpg"
		],
		title: "City Walking Tour",
		exploreLink: "city_walking_tour"
	},

	{
		carousel: [
			"./photos/evening_walking_tour/1.jpg",
			"./photos/evening_walking_tour/2.jpg",
			"./photos/evening_walking_tour/3.jpg"
		],
		title: "Evening Walking Tour",
		exploreLink: "evening_walking_tour"
	},

	{
		carousel: [
			"./photos/half_day_tour/1.jpg",
			"./photos/half_day_tour/2.jpg",
			"./photos/half_day_tour/3.jpg"
		],
		title: "Half Day Tour",
		exploreLink: "half_day_tour"
	},

	{
		carousel: [
			"./photos/camel_safari/1.jpg",
			"./photos/camel_safari/2.jpg",
			"./photos/camel_safari/3.jpg"
		],
		title: "Camel Safari, Jeep Safari and Quad Biking",
		exploreLink: "camel_safari_jeep_safari_and_quad_biking"
	},

	{
		carousel: [
			"./photos/hiking_and_trekking/1.jpg",
			"./photos/hiking_and_trekking/2.jpg",
			"./photos/hiking_and_trekking/3.jpg"
		],
		title: "Hiking and Trekking tours",
		exploreLink: ""
	},

	{
		carousel: [
			"./photos/tour_of_three_pushkar/1.jpg",
			"./photos/tour_of_three_pushkar/2.jpg",
			"./photos/tour_of_three_pushkar/3.jpg"
		],
		title: "Tour of Three Pushkar",
		exploreLink: ""
	},

	{
		carousel: [
			"./photos/hidden_gem/1.jpg",
			"./photos/hidden_gem/2.jpg",
			"./photos/hidden_gem/3.jpg"
		],
		title: "Hidden Glitterings Gems of Pushkar",
		exploreLink: ""
	},

	{
		carousel: [
			"./photos/holi_festival/1.jpg",
			"./photos/holi_festival/2.jpg",
			"./photos/holi_festival/3.jpg"
		],
		title: "Pushkar Holi Festival",
		exploreLink: ""
	},

	{
		carousel: [
			"./photos/pushkar_fair/1.jpg",
			"./photos/pushkar_fair/2.jpg",
			"./photos/pushkar_fair/3.jpg"
		],
		title: "Special Pushkar Fair",
		exploreLink: ""
	}
];

